import { 
	// Icon,
	 initializeIcons, 
	//  PrimaryButton 
	} from '@fluentui/react';
import { makeStyles, Typography } from '@material-ui/core';
import { api } from '@portal/arq-portal-core';
import * as React from 'react'
import { useEffect, useState } from 'react';
import { userAdapter } from './adapters/userAdapter';
import { ChartComponent } from './components/Chart/Chart.Component';
import { LoadingComponent } from './components/Loading/LoadingComponent';
import { User } from './models/User';
// import 'organigrama.css';


export const Organigrama = (props:any) => {
	const useStyles = makeStyles(() => ({
		message:{
		  fontSize:'12px',
		  lineHeight: '14px',
		},
		messagecontainer: {
		  display: 'flex',
		  backgroundColor: '#e0dfce',
		  borderLeft: '5px solid #5b5c43',
		  color: '#5b5c43',
		  alignItems: 'center',
		  padding: '10px 10px 10px 0px',
		  margin: '20px',
		  position:'absolute',
		  zIndex: 9,
		  '& i': {
			fontSize: '28px', 
			position: 'relative', 
			bottom: 0, 
			right: 0, 
			width: '40px',
			height: '32px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center'
		  },
		  '& a': {
			borderBottom:'1px solid #5b5c43',
			'&:hover': {
			  opacity: '0.7',
			}
		  }
	
		},
		generalWrapper: {
		  padding:'10px 20px'
		}
	  }
	  )); 
	const classes = useStyles(props);
	const [nodes, setNodes] = useState<any[]>([]);
	const [isLoading, setLoading] = useState(false);
	const service = "/be/organigrama/";
	const [showMessage, setShowMessage] =  React.useState(false);
	const [message, setMessage] =  React.useState("");
	const useServerInfo = ()=>api.post(service,{Enlace:{}});
    initializeIcons();
	// const DataExtractionPath = "https://grupoaplicaciones.gco.global/FE/ISF.AplCol.Gen.FE.BusDirPer/#";
	useEffect(() => {
		const init = async () => {
			setLoading(true);
			const salida = (await useServerInfo()).Salida;
			const users = salida.Usuarios;
			const userNodes = users.map((x:User) => userAdapter.adaptToUserNode(x));
			setShowMessage(salida?.MostrarMensaje ? salida?.MostrarMensaje : false);
			setMessage(salida?.Mensaje? salida?.Mensaje: "");
			setNodes(userNodes);
			setLoading(false);
		};

		init();
	}, []);

	return (
			<div>
				{ showMessage && <div className={classes.messagecontainer}>
					<i className={`icon-info-fixed`}> </i> 
					<Typography variant="body2" className={classes.message}>
					 {message}
					</Typography>
				</div>
				}	
				<link href="organigrama.css" rel="stylesheet" type="text/css" />
				{isLoading && <LoadingComponent />}
				{nodes.length > 0 && <React.Fragment>
					{/* <PrimaryButton onClick={() => document.location.assign(DataExtractionPath)} className='extraccion-btn'><Icon iconName='Installation' className='extraccion-icon' /> Extracción de datos</PrimaryButton>	 */}
					<ChartComponent nodes={nodes} />
				</React.Fragment>}
			</div>
	);
};
